export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const GET_ACCOUNT_INFO_REQUEST = 'GET_ACCOUNT_INFO_REQUEST';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';

export const GET_IDEAS_REQUEST = 'GET_IDEAS_REQUEST';
export const CREATE_IDEA_REQUEST = 'CREATE_IDEA_REQUEST';
export const UPDATE_IDEA_REQUEST = 'UPDATE_IDEA_REQUEST';
export const DELETE_IDEA_REQUEST = 'DELETE_IDEA_REQUEST';
export const ADD_NEW_IDEA = 'ADD_NEW_IDEA';
export const DISCARD_NEW_IDEA = 'DISCARD_NEW_IDEA';
export const UPDATE_FIELD = 'UPDATE_FIELD';
export const SET_IDEA = 'SET_IDEA';
